<template>
  <div>
    <mdb-tbl class="ml-3 my-2 fsize-m" sm >
      <mdb-tbl-head>
        <tr class="">
          <th>과목명</th>
          <th>단원수</th>
          <th>1차 평가</th>
          <th>2차 평가</th>
        </tr>
      </mdb-tbl-head>
      <mdb-tbl-body>
        <tr v-for="(s, i) in $normalSubjects(subjects)" :key="i">
          <td class="bolder">
            <mdb-icon icon="chalkboard-teacher" /> {{s.name}}
          </td>
          <td>{{s.lectures.length}}</td>
          <td>
            <div v-if="getTest(s.name, 1)">
              <span class="pointer" @click="onEdit(getTest(s.name, 1)._id)">
                {{$strDate(getTest(s.name, 1).testDate) || '날짜 없음'}}
              </span>
              <delete-btn-xs @click="onDelete(s.name, 1)"/>
            </div>
            <div v-else>
              <add-btn-sm  @click="onAdd(s, 1)">만들기</add-btn-sm>
            </div>
          </td>
          <td>
            <div v-if="getTest(s.name, 2)">
              <span class="pointer" @click="onEdit(getTest(s.name, 2)._id)">
                {{$strDate(getTest(s.name, 2).testDate)}}
              </span>
              <delete-btn-xs @click="onDelete(s.name, 2)"/>
            </div>
            <div v-else>
              <add-btn-sm  @click="onAdd(s, 2)">만들기</add-btn-sm>
            </div>
          </td>
        </tr>
      </mdb-tbl-body>
    </mdb-tbl>
  </div>
</template>
<script>
import { } from 'mdbvue';
export default {
  name: 'NonNcsWritingTestList',
  components: { },
  props: ['subjects'],
  data: () => ({
    TAG: 'NonNcsWritingTestList :',
    tests: [],
    test: undefined,
    task: undefined,
    show: false
  }),
  computed: { },
  methods: {
    getTest (code, seq) {
      if (!this.tests[code]) return undefined
      return this.tests[code][seq]
    },
    // 테스트 추가
    async onAdd (subject, seq) {
      if (!confirm('새로운 평가지를 만들까요?\n(새로운 평가지가 자동으로 등록됩니다.)')) return
      const { training } = this.$route.query
      const name = subject.name
      const questions = subject.lectures.map(l => ({
        unitName: l.name,
        unitCode: l.code,
        question: []
      }))
      let test = this.$WritingTest.create(training, 'NONNCS', subject.name, subject.name, subject.name, seq, questions)
      test = await test.save()
      this.onEdit(test._id)
    },
    // 테스트 수정
    onEdit (_id) {
      this.$router.push({
        path: 'edit',
        query: { _id }
      })
    },
    async onDelete (code, seq) {
      if (!confirm('삭제할까요?')) return
      await this.tests[code][seq].delete()
      this.tests[code][seq] = undefined
      if (seq === 1) {
        this.tests[code] = undefined
      }
    }
  },
  async created () {
    const { training } = this.$route.query
    this.tests = await this.$getWritingTest(training)
  }
}
</script>
